package com.solevo.dist.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.staticCompositionLocalOf
import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

object Localization {
    private const val KEY = "lang"
    private val _language = MutableStateFlow(loadInitial())
    private val _strings = MutableStateFlow(stringsFor(_language.value))

    val language: StateFlow<String> get() = _language
    val strings: StateFlow<Strings> get() = _strings

    fun setLanguage(code: String) {
        _language.value = code
        _strings.value = stringsFor(code)
        runCatching { window.localStorage.setItem(KEY, code) }
    }

    private fun loadInitial(): String {
        val saved = runCatching { window.localStorage.getItem(KEY) }.getOrNull()
        return saved ?: "en"
    }

    private fun stringsFor(code: String): Strings = when (code.lowercase()) {
        "en" -> StringsEn.value
        "fr" -> StringsFr.value
        "pt" -> StringsPt.value
        else -> StringsEn.value
    }
}

val LocalStrings = staticCompositionLocalOf { StringsEn.value }

@Composable
fun LocalizationProvider(content: @Composable () -> Unit) {
    val s by Localization.strings.collectAsState()
    CompositionLocalProvider(LocalStrings provides s) {
        content()
    }
}

